module.exports = __webpack_public_path__ + "static/media/matilde-normal.455e9fb8.png";